import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Navbar = ({ onClassesClick, onSoundHealingClick, onContactClick, onProductsClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navAction = (action) => {
    setMenuOpen(false);
    action();
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F9F6F0]/90 backdrop-blur-md border-b border-[#DCD6CC] shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            data-testid="nav-logo"
            className="flex items-center gap-2"
          >
            <img
              src="/logo.png"
              alt="Doz Aguas Logo"
              className="h-16 w-16 rounded-full object-cover"
            />
            <span className="font-['Cormorant_Garamond'] text-xl md:text-2xl font-semibold text-[#1A3626] tracking-tight">
              Doz Aguas
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            <button
              data-testid="nav-classes-link"
              onClick={onClassesClick}
              className="text-xs uppercase tracking-[0.2em] text-[#596B5B] hover:text-[#1A3626] transition-colors font-medium"
            >
              Dance Classes
            </button>
            <button
              data-testid="nav-sound-healing-link"
              onClick={onSoundHealingClick}
              className="text-xs uppercase tracking-[0.2em] text-[#596B5B] hover:text-[#1A3626] transition-colors font-medium"
            >
              Sound Healing
            </button>
            <button
              data-testid="nav-products-link"
              onClick={onProductsClick}
              className="text-xs uppercase tracking-[0.2em] text-[#596B5B] hover:text-[#1A3626] transition-colors font-medium"
            >
              Products
            </button>
            <button
              data-testid="nav-contact-link"
              onClick={onContactClick}
              className="text-xs uppercase tracking-[0.2em] text-[#596B5B] hover:text-[#1A3626] transition-colors font-medium"
            >
              Contact
            </button>
            <button
              data-testid="nav-book-class-btn"
              onClick={onClassesClick}
              className="px-5 py-2 bg-[#CC5543] text-white text-xs uppercase tracking-[0.15em] font-medium rounded-full hover:bg-[#A94334] transition-all duration-300"
            >
              Book a Class
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="nav-mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-[#1A3626]"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div
            data-testid="nav-mobile-menu"
            className="md:hidden pb-6 space-y-4 bg-[#F9F6F0]/95 backdrop-blur-md"
          >
            <button
              onClick={() => navAction(onClassesClick)}
              className="block w-full text-left text-sm uppercase tracking-[0.15em] text-[#596B5B] hover:text-[#1A3626] py-2"
            >
              Dance Classes
            </button>
            <button
              onClick={() => navAction(onSoundHealingClick)}
              className="block w-full text-left text-sm uppercase tracking-[0.15em] text-[#596B5B] hover:text-[#1A3626] py-2"
            >
              Sound Healing
            </button>
            <button
              onClick={() => navAction(onProductsClick)}
              className="block w-full text-left text-sm uppercase tracking-[0.15em] text-[#596B5B] hover:text-[#1A3626] py-2"
            >
              Products
            </button>
            <button
              onClick={() => navAction(onContactClick)}
              className="block w-full text-left text-sm uppercase tracking-[0.15em] text-[#596B5B] hover:text-[#1A3626] py-2"
            >
              Contact
            </button>
            <button
              onClick={() => navAction(onClassesClick)}
              className="block w-full text-center px-5 py-3 bg-[#CC5543] text-white text-xs uppercase tracking-[0.15em] font-medium rounded-full hover:bg-[#A94334]"
            >
              Book a Class
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
